import { defineStore } from 'pinia';
import { Monetary } from '../../utils/Monetary';

export const useClientState = defineStore('repo.client.state', () => {
    const {
        $locally,
        $session,
        $i18n,
        $translations,
    }: any = useNuxtApp();

    callOnce(async () => {
        await $translations('$pipeline.app.validation.cart');
    });

    const settings = ref($locally.getSettings());
    const monetary = ref(new Monetary($i18n, settings.value));
    const session = ref($session.getSession());

    watch(settings, (settingsN: any, settingsO: any) => {
        monetary.value.update(settingsN);
        $locally.setItem('pipeline.settings', settingsN);

        if ((settingsN.country !== settingsO.country ||
            settingsN.currency !== settingsO.currency ||
            settingsN.language !== settingsO.language)
            && session.value?.payment) {
            ['paymentId', 'snippet'].forEach(prop => {
                if (prop in session.value.payment) {
                    delete session.value.payment[prop as keyof typeof session.value.payment];
                }
            });
        }
    }, { deep: true, flush: 'post' });

    watch(session, async (sessionN: any) => {
        $session.setItem('pipeline.session', sessionN);
    }, { deep: true });

    const page = ref(null); // Is set in route.ts.

    // REFS NODES
    const nodes = reactive({});

    // Watcher to set page nodes data.
    watch(page, async () => {
        // TODO: Load once.
        for (const [key, value] of Object.entries(page.value.nodes)) {
            switch (typeof value) {
                case 'string': {
                    nodes[key] = page.value.navigationNodes.find((node: any) => node.id === value);
                    break;
                }
                case 'object': {
                    if (Array.isArray(value)) {
                        nodes[key] = value.map(id => page.value.navigationNodes.find((node: any) => node.id === id));
                    }
                    break;
                }
                default:
                    break;
            }
        }
    });

    return {
        settings,
        session,
        nodes,
        monetary,
        page
    };
})